exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-message[data-v-124fa853]{border:1px dashed red;text-align:center;padding:10px;margin-top:10px;color:red;margin-bottom:10px}.form-control[data-v-124fa853]{background-color:#fff!important}.text-xl[data-v-124fa853]{font-size:20px;font-weight:700}.text-lg[data-v-124fa853]{font-size:16px;font-weight:700}.text-md[data-v-124fa853]{font-size:14px;color:green}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib??vue-loader-options!./src/components/paywall/usage/AssociateOrgsConfig.vue?vue&type=style&index=0&id=124fa853&prod&scoped=true&lang=css&
// module id = 1453
// module chunks = 0